import { Icon } from '@iconify/react';
import { useDispatch } from 'react-redux';

import { useFormik, FormikProvider } from 'formik';
import saveIcon from '@iconify/icons-eva/save-outline';
// material
import { Stack, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import { editItem } from '../../fetch';
import { useTranslation } from '../../common/LocalizationProvider';
import { aerosActions } from '../../store';

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

RunwaysForm.propTypes = {
  runwayId: PropTypes.number,
  runway: PropTypes.object,
  oaci: PropTypes.string
};

export default function RunwaysForm({ runwayId, runway, oaci }) {
  const t = useTranslation();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  const initialValues = {
    oaci: oaci || '',
    qfu: '',
    longueur: '',
    largeur: '',
    s1Lat: '',
    s1Lon: '',
    s1Alt: '',
    s2Alt: '',
    s2Lat: '',
    s2Lon: '',
    type: ''
  };

  const formik = useFormik({
    initialValues: runway !== undefined ? runway : initialValues,
    onSubmit: async (values) => {
      const response = await editItem('aeros/runway', runwayId, values);
      if (response.ok) {
        enqueueSnackbar(
          runway !== undefined ? t('Runway_Snackbar_Change') : t('Runway_Snackbar_Add'),
          {
            variant: 'success'
          }
        );
        dispatch(aerosActions.updateRunways([await response.json()]));
        navigate(-1);
      } else {
        const error = await response.text();
        const message = error.slice(0, error.indexOf('-'));
        enqueueSnackbar(message, { variant: 'error' });
        setSubmitting(false);
      }
    }
  });

  const { handleSubmit, isSubmitting, getFieldProps, setSubmitting } = formik;

  return (
    <FormikProvider value={formik}>
      <Stack spacing={3}>
        <TextField fullWidth autoComplete="oaci" label="oaci" {...getFieldProps('oaci')} />
        <TextField
          fullWidth
          autoComplete="qfu"
          type="number"
          label={t('fields_qfu')}
          {...getFieldProps('qfu')}
        />

        <TextField
          fullWidth
          autoComplete="longueur"
          type="number"
          label={t('fields_length')}
          {...getFieldProps('longueur')}
        />

        <TextField
          fullWidth
          autoComplete="largeur"
          type="number"
          label={t('fields_width')}
          {...getFieldProps('largeur')}
        />

        <TextField
          fullWidth
          autoComplete="s1Lat"
          {...getFieldProps('s1Lat')}
          label={t('latitude_begin_runway')}
        />

        <TextField
          fullWidth
          autoComplete="s1Lon"
          {...getFieldProps('s1Lon')}
          label={t('longitude_begin_runway')}
        />

        <TextField
          fullWidth
          autoComplete="s1Alt"
          {...getFieldProps('s1Alt')}
          label={t('alt_begin_runway')}
        />
        <TextField
          fullWidth
          autoComplete="s2Lat"
          {...getFieldProps('s2Lat')}
          label={t('latitude_end_runway')}
        />

        <TextField
          fullWidth
          autoComplete="s2Lon"
          {...getFieldProps('s2Lon')}
          label={t('longitude_end_runway')}
        />

        <TextField
          fullWidth
          autoComplete="s2Alt"
          {...getFieldProps('s2Alt')}
          label={t('alt_end_runway')}
        />
        <TextField
          fullWidth
          autoComplete="type"
          {...getFieldProps('type')}
          label={t('type_runway')}
        />

        <LoadingButton
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          loading={isSubmitting}
          startIcon={<Icon icon={saveIcon} />}
          onClick={handleSubmit}
        >
          {t('btn_Save')}
        </LoadingButton>
      </Stack>
    </FormikProvider>
  );
}
